import { Component } from '@angular/core';
import { BasePluginMenuComponent } from './base.menu';

@Component({
    templateUrl: './edit-upgrades.menu.html',
    standalone: false
})
export class UpgradesMenuComponent extends BasePluginMenuComponent {}
